import { Injectable } from "@angular/core";
// import { ApiHttpClient, BaseComponentContext, BroadcastService, NavigationService, NotificationsService } from "@tcm-modules/tcm-core.module";
import { TcmModalService } from "./tcm-modal.service";
import { ApiEventsService } from '../../../services/api-events.service';
import { BaseComponentContext } from "../../tcm-core.module/services/base-component-context.service";
import { NavigationService } from "../../tcm-core.module/services/navigation.service";
import { ApiHttpClient } from "../../tcm-core.module/services/api-http-client";
import { BroadcastService } from "../../tcm-core.module/services/broadcast.service";
import { NotificationsService } from "../../tcm-core.module/services/notification.service";

@Injectable()
export class TcmBaseComponentContext extends BaseComponentContext{
    constructor(public override http: ApiHttpClient, public override navService: NavigationService, 
                public override notificationService: NotificationsService, public modalService: TcmModalService,
                public override broadcastService: BroadcastService,
                public apiEventSvc: ApiEventsService) {
                    super(http, navService, notificationService, broadcastService);
    }
}